import { render, staticRenderFns } from "./ContentShowDialog.vue?vue&type=template&id=c606e456"
import script from "./ContentShowDialog.vue?vue&type=script&lang=js"
export * from "./ContentShowDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports